import React from "react";
import { string, elementType } from "prop-types";
import { Field } from "formik";
import { makeStyles } from "@material-ui/core/styles";

import InputAdornment from "@material-ui/core/InputAdornment";
import CustomInput from "@vendors/CreativeTim/components/CustomInput/CustomInput.js";
import style from "./style";

const useStyle = makeStyles(style);

const Input = ({ type, name, label, autoComplete, icon: Icon }) => {
  const classes = useStyle();

  return (
    <Field name={name}>
      {({ field, meta: { touched, error } }) => (
        <CustomInput
          success={Boolean(touched && !error)}
          error={Boolean(touched && error)}
          labelText={label}
          id={name}
          helperText={error}
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            ...field,
            autoComplete,
            type,
            endAdornment: Icon ? (
              <InputAdornment position="end">
                <Icon className={classes.inputAdornmentIcon} />
              </InputAdornment>
            ) : null,
          }}
        />
      )}
    </Field>
  );
};

Input.propTypes = {
  type: string,
  name: string.isRequired,
  label: string.isRequired,
  autoComplete: string,
  icon: elementType,
};

export default Input;
